export function arrayUnique(array) {
  // filter out duplicate occurances by making sure only the first index with that value will be passed through.
  return array.filter((val, i, arr) => arr.indexOf(val) === i);
}
export function arrayUniqueByKey(array, key) {
  // take advantage of Map allowing only one entry to exist for a certain key.
  // by converting into map<key, item> and back to an Array we strip away all duplicates.
  return [...new Map(array.map(item => [item[key], item])).values()];
}